import { useState } from 'react';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Link, NavLink } from 'react-router-dom';
import styles from './styles.module.scss';
import ClockIcon from '@/common/svg/clock-icon.svg';
import EmailIcon from '@/common/svg/email-icon.svg';
import MastercardIcon from '@/common/svg/mastercard-icon.svg';
import PhoneIcon from '@/common/svg/phone-icon.svg';
import VisaIcon from '@/common/svg/visa-icon.svg';
import DocumentsList from '@/components/DocumentsList';
import { Licence } from '@/components/Licence';
import Modal from '@/components/Modal';
import { WorkingTime } from '@/components/WorkingTime';
import { commonDocuments } from '@/entities/Footer/models/documents';
import { MainButton } from '@/shared/MainButton';

export const Footer = () => {
  const [showDocModal, setShowDocModal] = useState(false);

  const handleDocumentsModal = () => {
    setShowDocModal((prev) => !prev);
  };

  return (
    <footer className={cn('section', styles.footer)}>
      <div className={cn('container', styles.container)}>
        <div className={cn(styles.block, styles.topBlock)}>
          <div>
            <div className={styles.contacts}>
              <div className={styles.row}>
                <PhoneIcon />
                <Link id="footer-link-phone" to="tel:+77089128007">
                  +7 708 912 80 07
                </Link>
              </div>
              <div className={styles.row}>
                <EmailIcon />
                <Link id="footer-link-mailto" to="mailto:info@neocredit.kz">
                  info@neocredit.kz
                </Link>
              </div>
              <div className={cn(styles.row, styles.alignTop)}>
                <ClockIcon />
                <WorkingTime />
              </div>
            </div>
            <div className={cn('desktop-display', styles.cardsContainer)}>
              <VisaIcon />
              <MastercardIcon />
            </div>
          </div>
          <div className="desktop-display">
            <Licence />
          </div>
        </div>
        <nav className={cn(styles.block, styles.navBlock)}>
          <NavLink id="footer-link-loan-conditions" to="/loan-conditions">
            <FormattedMessage defaultMessage="Условия предоставления микрокредитов" />
          </NavLink>
          <NavLink id="footer-link-feedback" to="/feedback">
            <FormattedMessage defaultMessage="Оставить отзыв" />
          </NavLink>
          <NavLink id="footer-link-complaint" to="/complaint">
            <FormattedMessage defaultMessage="Оставить жалобу" />
          </NavLink>
          <NavLink id="footer-link-how-get-money" to="/how-get-money">
            <FormattedMessage defaultMessage="Как получить деньги" />
          </NavLink>
          <NavLink id="footer-link-payments-info" to="/payments-info">
            <FormattedMessage defaultMessage="Как вернуть деньги" />
          </NavLink>
          <NavLink id="footer-link-faq" to="/faq">
            <FormattedMessage defaultMessage="Вопрос - ответ (помощь)" />
          </NavLink>
          <NavLink id="footer-link-contacts" to="/contacts">
            <FormattedMessage defaultMessage="Контакты" />
          </NavLink>
        </nav>
        <div className={cn(styles.block, styles.bottomBlock)}>
          <div className={cn('mobile-display', styles.cardsContainer)}>
            <VisaIcon />
            <MastercardIcon />
          </div>
          <div className={styles.infoWrapper}>
            <MainButton
              id="footer-show-documents"
              className={styles.footerButton}
              text={<FormattedMessage defaultMessage="Документы" />}
              onClick={handleDocumentsModal}
            />
            <div className={styles.info}>
              <p className={styles.text}>
                <FormattedMessage defaultMessage="ТОО Микрофинансовая организация" />
                <br />
                <span>«LEGAL MONEY»</span>
              </p>
              <p className={styles.text}>
                <FormattedMessage defaultMessage="РК, г. Алматы, 050057, ул. Толе би, 101" />
                <br />
                <FormattedMessage defaultMessage="БЦ «Толе би», 3 этаж, блок D" />
              </p>
              <p className={styles.text}>
                <FormattedMessage defaultMessage="БИН" />
                <span>: 220440007472</span>
                <br />
                <FormattedMessage defaultMessage="ОКЭД" />
                <span>: 64929</span>
                <br />
                <FormattedMessage defaultMessage="р/с" />
                <span>: KZ55601A861010717701</span>
                <br />
                <FormattedMessage defaultMessage="АО «Народный Банк Казахстана», каб. 15" />
              </p>
              <p className={styles.text}>
                <FormattedMessage defaultMessage="БИК" />
                <span>: HSBKKZKX</span>
              </p>
            </div>
          </div>
          <div className="mobile-display">
            <Licence />
          </div>
        </div>
      </div>
      {showDocModal && (
        <Modal
          show={showDocModal}
          onClose={handleDocumentsModal}
          title={<FormattedMessage defaultMessage="Документы" />}
          mobileFullSize
        >
          <DocumentsList documents={commonDocuments} />
        </Modal>
      )}
    </footer>
  );
};
